import  axios from 'axios'
import { getSessionToken, getCsrfToken} from "@futures-platform/connectors/session"

const baseUrl = process.env.REACT_APP_COMMENTING_API_URL
async function httpRequest(baseUrl, method, path, payload = null) {
  return axios({
      method,
      url: `${baseUrl}/${path}`,
      headers: {
          'X-CSRF-Token': getCsrfToken(),
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getSessionToken()}`
      },
      withCredentials: true,
      data: payload || null
  })
}

export const commentingApi = {
    //get all votes from all phenomenon by radarId
    getAllComments: async (gid, radarId) => {
        if(!gid || gid === 'NaN' || gid === undefined) return null
        return await httpRequest(baseUrl, 'GET', `commenting/${gid}/radar/${radarId}`)

    },

    getAllCommentsByPhenId: async (gid, radarId, phenId) => {
        if(!gid || gid === 'NaN' || gid === undefined) return null
        return await httpRequest(baseUrl, 'GET', `commenting/${gid}/radar/${radarId}/phenomenon/${phenId}`)
    },

    // add or edit comment
    upsertComment: async (gid, radarId, pid, section, cmtId, payload) => {
        if(!gid || gid === 'NaN' || gid === undefined) return null
        return await httpRequest(baseUrl, 'POST', `commenting/${gid}/radar/${radarId}/phenomenon/${pid}/${section}/${cmtId}`, payload)
    },

    //delete all cmts from all phenomenon by radarId
    deleteComment: async (gid, radarId, pid, section, cmtId) => {
        if(!gid || gid === 'NaN' || gid === undefined) return null
        return await httpRequest(baseUrl, 'DELETE', `commenting/${gid}/radar/${radarId}/phenomenon/${pid}/${section}/${cmtId}`)
    }
}